import { render, staticRenderFns } from "./Terminales.vue?vue&type=template&id=4b174c28&"
import script from "./Terminales.vue?vue&type=script&lang=js&"
export * from "./Terminales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports